import React from "react";

const DynamicField = ({ tutorDetails, setTutorDetails }) => {
  const handleDynamicFieldChange = (index, value) => {
    const updatedDynamicFields = [...tutorDetails.dynamicFields];
    updatedDynamicFields[index] = value;
    setTutorDetails((prevDetails) => ({
      ...prevDetails,
      dynamicFields: updatedDynamicFields,
    }));
  };

  const addDynamicField = () => {
    setTutorDetails((prevDetails) => ({
      ...prevDetails,
      dynamicFields: [...prevDetails.dynamicFields, ""],
    }));
  };

  const removeDynamicField = (index) => {
    const updatedDynamicFields = tutorDetails.dynamicFields.filter(
      (_, i) => i !== index
    );
    setTutorDetails((prevDetails) => ({
      ...prevDetails,
      dynamicFields: updatedDynamicFields,
    }));
  };

  return (
    <div className="dynamic-fields-section">
      {tutorDetails.dynamicFields.map((field, index) => (
        <div key={index} className="dynamic-field">
          <input
            type="text"
            placeholder={`Enter details ${index + 1}`}
            value={field}
            onChange={(e) => handleDynamicFieldChange(index, e.target.value)}
            className="form-control"
          />
          <button
            type="button"
            className="remove-field-btn"
            onClick={() => removeDynamicField(index)}
          >
            Remove
          </button>
        </div>
      ))}
      <button type="button" className="add-field-btn" onClick={addDynamicField}>
        Add Custom Field
      </button>
    </div>
  );
};

export default DynamicField;
